module.exports = __webpack_public_path__ + "templates.apple_pay_with_newebpay_button-586792f0.html";